import { render, staticRenderFns } from "./VesselDocuments.vue?vue&type=template&id=5663fcd4&scoped=true&"
import script from "./VesselDocuments.vue?vue&type=script&lang=js&"
export * from "./VesselDocuments.vue?vue&type=script&lang=js&"
import style0 from "./VesselDocuments.vue?vue&type=style&index=0&id=5663fcd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663fcd4",
  null
  
)

export default component.exports